export default "__VITE_ASSET__GYxLk_yF__"